// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetCategoryCodeService = {};

AssetCategoryCodeService.getAssetCategoryCodeList = function (userInput) {
  return lossClient({
    url: "/AssetCategory/Items?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetCategoryCodeService;
